import { useHotelReserveRacks } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-racks/hotel-reserve-card-racks.hooks";
import { HotelReserveCardRacksPropertiesTypes } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-racks/hotel-reserve-card-racks.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { CounterButton } from "@website/ui/counter-button";
import { MiniChips } from "@website/ui/mini-chips";
import { Modal } from "@website/ui/modal";
import { RadioGroup } from "@website/ui/radio-group";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = (properties: HotelReserveCardRacksPropertiesTypes) => {
  const { open, onClose } = properties;
  const router = useRouter();
  const {
    items,
    onChange,
    packageSelect,
    roomCount,
    onHandleClick,
    loading,
    setRoomCount,
    selectedPackageIndex
  } = useHotelReserveRacks(properties);

  return (
    <Modal
      className="!z-[29] p-0 md:min-w-[448px]"
      onClose={onClose}
      open={open}
    >
      <div className="flex h-full flex-col gap-4 pt-8">
        <div className="text-subtitle-1 flex flex-row justify-between px-8">
          <div>تغییر بازه انتخابی</div>
          <MaterialIcon
            className="cursor-pointer"
            name="close"
            onClick={onClose}
          />
        </div>
        <div className="flex flex-col gap-2 px-8">
          <div className="text-body-2 pb-4">
            این اتاق صرفا در بازه‌های اقامتی مشخصی قابل رزرو است.
          </div>
          <div className="text-body-2 pb-2">{" تاریخ های قابل رزرو: "}</div>
          <RadioGroup
            className="!w-full !items-start gap-4"
            itemClassName="!w-full"
            items={items || []}
            name="packages"
            onChange={onChange}
            radioClassName="border-secondary rounded-lg border py-2 pe-4 ps-6 !w-full flex-row-reverse min-h-[72px]"
            vertical
            value={Number(router?.query?.["packages"])}
          />
          {/*<div*/}
          {/*  className="border-secondary flex h-[72px] cursor-pointer flex-row items-center justify-between rounded-lg border px-6 py-2"*/}
          {/*  onClick={() => {*/}
          {/*    onClose();*/}
          {/*    roomDetail?.onClick?.({*/}
          {/*      roomId: roomDetail?.id,*/}
          {/*      tabSelected: "roomCalendar",*/}
          {/*      availableRooms: roomDetail?.availableRooms*/}
          {/*    });*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <div className="flex">{"انتخاب روزهای دیگر از روی تقویم"}</div>*/}
          {/*  <MaterialIcon name="arrow_back_ios_new" />*/}
          {/*</div>*/}
        </div>
        <div className="flex h-full flex-col justify-end gap-4 px-8 pb-8">
          <div className="flex w-full flex-row items-center justify-between">
            <div className="text-body-2 text-on-surface-medium-emphasis px-1">{`${numberConvert(
              packageSelect?.nightCount,
              { locale: router.locale }
            )} شب`}</div>
            <div>
              {packageSelect &&
                Boolean(packageSelect?.price - packageSelect?.priceOff) && (
                  <div className="flex flex-row items-center justify-between gap-2">
                    <span className="text-body-2 text-on-surface-medium-emphasis line-through">
                      {numberConvert(numberSeparator(packageSelect?.price), {
                        locale: router.locale
                      })}
                    </span>
                    <MiniChips
                      color="primary"
                      text={`${numberConvert(
                        (
                          ((packageSelect?.price - packageSelect?.priceOff) /
                            packageSelect?.price) *
                          100
                        ).toFixed(0),
                        {
                          locale: router.locale
                        }
                      )}%`}
                      variant="contained"
                    />
                  </div>
                )}
              <div className="text-subtitle-1">
                {packageSelect &&
                  numberConvert(
                    numberSeparator(
                      (packageSelect?.price - packageSelect?.priceOff
                        ? packageSelect?.priceOff
                        : packageSelect?.price) * roomCount
                    ),
                    {
                      locale: router.locale
                    }
                  )}
                <span className="text-subtitle-2 ps-1">تومان</span>
              </div>
            </div>
          </div>
          <div className="flex w-full flex-row items-center justify-between gap-4">
            <CounterButton
              className="gap-0"
              color="secondary"
              decreaseDisabled={roomCount <= 1}
              increaseDisabled={
                roomCount >=
                (packageSelect?.availableRoom ?? Number.POSITIVE_INFINITY)
              }
              locale="fa"
              onChange={setRoomCount}
              size="small"
              value={roomCount}
              variant="outline"
            />
            <Button
              className="w-[160px]"
              disabled={Boolean(!selectedPackageIndex)}
              loading={loading}
              onClick={onHandleClick}
            >
              {`رزرو ${numberConvert(roomCount, {
                locale: router.locale
              })} اتاق`}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export const HotelReserveCardRacks = memo(Component, deepCompare);
